import { z } from "zod";

export const registerSchema = z.object({
  firstName: z.string().min(5, { message: "این فیلد الزامی است" }),
  lastName: z.string().min(5, { message: "این فیلد الزامی است" }),
  email: z.string().email({ message: "ایمیل خود را به درستی وارد کنید" }),
  phoneNumber: z.string().min(5, { message: "این فیلد الزامی است" }),
});

export const otpCodeSchema = z.object({
  otpCode: z.string().min(6, { message: "otpCode_incorrect_error" }),
});

export type OtpCodeFormFields = z.infer<typeof otpCodeSchema>;

export type registerFormFields = z.infer<typeof registerSchema>;
